"use strict";
function Link(link) {
    return {
        get format() {
            if (!link)
                return '';
            if (link?.includes('http'))
                return link;
            return `https://${link}`;
        }
    };
}
window.Link = Link;
//# sourceMappingURL=index.js.map